interface ITextFieldSkeleton {
  isLoading?: boolean
  children: React.ReactNode
}
const TextFieldSkeleton: React.FC<ITextFieldSkeleton> = ({
  isLoading,
  children
}) => {
  return (
    <>
      {isLoading ? (
        <div role="status" className="animate-pulse">
          <div className="h-10 bg-gray-100 rounded-lg dark:bg-gray-200"></div>
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        children
      )}
    </>
  )
}

export default TextFieldSkeleton
